var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-viewer"},[_c('div',{staticStyle:{"font-size":"4rem"}},[_vm._v("Helixiser Figure "+_vm._s(_vm.$route.params.id))]),_c('div',[_vm._v("running from node: "+_vm._s(_vm.usingNode))]),_c('fourier-panel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }